"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.createDropdownOptions = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("@nicbase/hooks");

var _mapping = require("@nicbase/mapping");

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseReducers = require("nicbase-reducers");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

var _useTourboardAssets2 = _interopRequireDefault(require("../useTourboardAssets"));

var _loadingStepModule = _interopRequireDefault(require("./loading-step.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var USE_EXISTING_ASSET = 'USE_EXISTING_ASSET';
var CREATE_NEW_ASSET = 'CREATE_NEW_ASSET';
var DATA_REQUEST = 'DATA_REQUEST';

var createDropdownOptions = function createDropdownOptions(assets) {
  return assets.sort(function (a, b) {
    return a.name > b.name ? 1 : -1;
  }).reduce(function (result, asset) {
    var newResult = result;
    newResult[asset.id] = asset.name;
    return newResult;
  }, {});
};

exports.createDropdownOptions = createDropdownOptions;

var LoadingStep = function LoadingStep(_ref) {
  var _formData$asset, _formData$asset2, _formData$asset3, _formData$asset$coupl2, _formData$asset4, _formData$asset5, _formData$asset$coupl3, _formData$asset$coupl4, _formData$asset$coupl5, _formData$asset$coupl6, _formData$asset$coupl7, _formData$asset$coupl8, _formData$asset$coupl9, _formData$asset6, _touched$asset, _errors$asset, _formData$asset7, _formData$asset7$coup, _formData$dataRequest2;

  var formData = _ref.formData,
      setFieldValue = _ref.setFieldValue,
      setFieldTouched = _ref.setFieldTouched,
      isNewTour = _ref.isNewTour,
      assetSelection = _ref.assetSelection,
      setAssetSelection = _ref.setAssetSelection,
      isLoadingCoupledAsset = _ref.isLoadingCoupledAssets,
      touched = _ref.touched,
      errors = _ref.errors;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _usePortal = (0, _nicbaseReducers.usePortal)(),
      portalId = _usePortal.id;

  var _usePermissions = (0, _nicbaseSecurity.usePermissions)('PORTAL'),
      hasPermissions = _usePermissions.hasPermissions;

  var _usePortalAssets = (0, _hooks.usePortalAssets)(portalId),
      _usePortalAssets$data = _usePortalAssets.data,
      assets = _usePortalAssets$data === void 0 ? [] : _usePortalAssets$data; // all assets, incl. coupled assets


  var _useTourboardAssets = (0, _useTourboardAssets2["default"])(),
      allAssets = _useTourboardAssets.data,
      isLoadingAssets = _useTourboardAssets.isLoading;

  var assetDropdownOptions = (0, _react.useMemo)(function () {
    return createDropdownOptions(assets);
  }, [assets]);
  var allAssetDropdownOptions = (0, _react.useMemo)(function () {
    return createDropdownOptions(allAssets);
  }, [allAssets]);

  var _usePortalLinkedPorta = (0, _hooks.usePortalLinkedPortals)(portalId, {
    select: function select(portals) {
      return Object.keys(portals).reduce(function (result, nextPortalId) {
        var nextResult = result;
        nextResult[nextPortalId] = portals[nextPortalId].name;
        return nextResult;
      }, {});
    }
  }),
      _usePortalLinkedPorta2 = _usePortalLinkedPorta.data,
      linkedPortalSource = _usePortalLinkedPorta2 === void 0 ? {} : _usePortalLinkedPorta2,
      isLoadingLinkedPortals = _usePortalLinkedPorta.isLoading; // update form on asset selection change


  var prevAssetSelection = (0, _hooks.usePrevious)(assetSelection);
  (0, _hooks.useDidUpdate)(function () {
    if (assetSelection !== prevAssetSelection) {
      // reset touched state
      setFieldTouched('loadingStep', false);

      if (assetSelection === USE_EXISTING_ASSET) {
        setFieldValue('loadingStep', {
          asset: {},
          dissolveTrainAfterTour: false,
          dataRequest: null
        });
      } else if (assetSelection === CREATE_NEW_ASSET) {
        setFieldTouched("loadingStep.asset.coupledAssets.".concat(0), false);
        setFieldValue('loadingStep', {
          asset: {
            type: 240,
            coupledAssets: [{} // there should always be at least one coupled asset
            ]
          },
          dataRequest: null,
          dissolveTrainAfterTour: true
        });
      } else if (assetSelection === DATA_REQUEST) {
        setFieldValue('loadingStep', {
          asset: {},
          dissolveTrainAfterTour: false,
          dataRequest: {
            type: 'PORTAL',
            haulerPortalId: null,
            haulerEmail: null
          }
        });
      }
    }
  }, [assetSelection, prevAssetSelection, setFieldTouched, setFieldValue]);

  var onAssetChange = function onAssetChange(id) {
    var updatedAsset = {};

    if (id) {
      updatedAsset = allAssets.find(function (asset) {
        return asset.id === id;
      });

      if (!(0, _mapping.isCoupledAsset)(updatedAsset.type)) {
        updatedAsset.coupledAssets = [_objectSpread({}, updatedAsset)];
      }
    }

    setFieldTouched('loadingStep.asset');
    setFieldValue('loadingStep.asset', updatedAsset);
  };

  var onAssetNameChange = function onAssetNameChange(name) {
    setFieldTouched('loadingStep.asset.name');
    setFieldValue('loadingStep.asset.name', name);
  };

  var onDissolveTrainAfterTourChange = function onDissolveTrainAfterTourChange(value) {
    setFieldValue('loadingStep.dissolveTrainAfterTour', value);
  };

  var onAddCoupledAssetClicked = function onAddCoupledAssetClicked() {
    var coupledAssets = [].concat(_toConsumableArray(formData.asset.coupledAssets), [{} // new empty coupled asset
    ]);
    setFieldTouched("loadingStep.asset.coupledAssets.[".concat(formData.asset.coupledAssets.length, "]"), false);
    setFieldValue('loadingStep.asset.coupledAssets', coupledAssets);
  };

  var onRemoveCoupledAssetClicked = function onRemoveCoupledAssetClicked(index) {
    var coupledAssets = formData.asset.coupledAssets.slice();
    coupledAssets.splice(index, 1);
    var coupledAssetsTouched = touched.asset.coupledAssets.slice();
    coupledAssetsTouched.splice(index, 1);
    setFieldTouched('loadingStep.asset.coupledAssets', false);
    coupledAssetsTouched.forEach(function (coupledAssetTouched, i) {
      setFieldTouched("loadingStep.asset.coupledAssets.[".concat(i, "]"), coupledAssetTouched);
    });
    setFieldValue('loadingStep.asset.coupledAssets', coupledAssets);
  };

  var onCoupledAssetChange = function onCoupledAssetChange(index, id) {
    setFieldTouched("loadingStep.asset.coupledAssets.[".concat(index, "]"));
    setFieldValue("loadingStep.asset.coupledAssets.[".concat(index, "]"), _objectSpread(_objectSpread({}, formData.asset.coupledAssets[index]), {}, {
      id: id
    }));
  };

  var onCoupledAssetPropChange = function onCoupledAssetPropChange(index, key, value) {
    setFieldValue("loadingStep.asset.coupledAssets.[".concat(index, "]"), _objectSpread(_objectSpread({}, formData.asset.coupledAssets[index]), {}, _defineProperty({}, key, value)));
  };

  var onWeightChange = function onWeightChange(index, weight) {
    if (weight) {
      var weightNumber = parseInt(weight.replace(/([^\d])/g, ''), 10);

      if (Number.isInteger(weightNumber)) {
        onCoupledAssetPropChange(index, 'weight', weightNumber);
      }
    } else {
      onCoupledAssetPropChange(index, 'weight', '');
    }
  };

  var onDataRequestPortalChange = function onDataRequestPortalChange(selectedPortalId) {
    setFieldTouched('loadingStep.dataRequest.haulerPortalId');
    setFieldValue('loadingStep.dataRequest.haulerPortalId', selectedPortalId);
  };

  if (!isNewTour && assetSelection !== DATA_REQUEST) {
    var _formData$asset$coupl;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-full w-128 px-2 mx-12"
    }, isLoadingCoupledAsset ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
      title: formData.asset.name
    }), (_formData$asset$coupl = formData.asset.coupledAssets) === null || _formData$asset$coupl === void 0 ? void 0 : _formData$asset$coupl.map(function (coupledAsset, index) {
      var _coupledAsset$weight;

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: coupledAsset.id,
        className: "mt-4"
      }, (0, _mapping.isCoupledAsset)(formData.asset.type) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-base text-primary font-bold"
      }, coupledAsset.name), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.loading.weight"
        }),
        name: "weight",
        value: (_coupledAsset$weight = coupledAsset.weight) === null || _coupledAsset$weight === void 0 ? void 0 : _coupledAsset$weight.toString(),
        onChange: function onChange(weight) {
          return onWeightChange(index, weight);
        },
        maxLength: 64
      }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
        type: "text",
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.loading.nhmCode"
        }),
        name: "nhmCode",
        value: coupledAsset.nhmCode,
        onChange: function onChange(nhmCode) {
          return onCoupledAssetPropChange(index, 'nhmCode', nhmCode);
        },
        maxLength: 64
      }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
        type: "text",
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.loading.description"
        }),
        name: "productDescription",
        value: coupledAsset.productDescription,
        onChange: function onChange(productDescription) {
          return onCoupledAssetPropChange(index, 'productDescription', productDescription);
        },
        maxLength: 64
      }));
    })));
  }

  if (!isNewTour && assetSelection === DATA_REQUEST) {
    var _formData$dataRequest;

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-full w-128 px-2 mx-12"
    }, isLoadingLinkedPortals ? /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.SectionHeader, {
      title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.createTour.loading.dataRequest"
      })
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.createTour.loading.dataRequestedFrom"
      }),
      source: linkedPortalSource,
      value: (_formData$dataRequest = formData.dataRequest) === null || _formData$dataRequest === void 0 ? void 0 : _formData$dataRequest.haulerPortalId,
      onChange: function onChange(id) {
        return onDataRequestPortalChange(parseInt(id, 10) || null);
      }
    })));
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-full w-128 px-2 mx-12"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioGroup, {
    className: "mb-4",
    onChange: setAssetSelection,
    value: assetSelection
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioButton, {
    value: USE_EXISTING_ASSET,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.existingAsset"
    })
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioButton, {
    value: CREATE_NEW_ASSET,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.newAsset"
    })
  }), Object.keys(linkedPortalSource).length > 0 && hasPermissions(['module.tour.dataRequest.columns']) && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.RadioButton, {
    value: DATA_REQUEST,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.dataRequest"
    })
  })), (isLoadingAssets || isLoadingLinkedPortals) && /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null), !isLoadingAssets && assetSelection === USE_EXISTING_ASSET && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, {
      className: "fill-primary inline-block"
    }),
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.asset"
    }, function (message) {
      return "".concat(message, "*");
    }),
    source: allAssetDropdownOptions,
    value: (_formData$asset = formData.asset) === null || _formData$asset === void 0 ? void 0 : _formData$asset.id,
    valueType: "Integer",
    onChange: onAssetChange,
    error: touched.asset && errors.asset ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.asset.error"
    }) : null
  }), ((_formData$asset2 = formData.asset) === null || _formData$asset2 === void 0 ? void 0 : _formData$asset2.id) && (0, _mapping.isCoupledAsset)((_formData$asset3 = formData.asset) === null || _formData$asset3 === void 0 ? void 0 : _formData$asset3.type) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isLoadingCoupledAsset && /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.NicbaseSpinnerComponent, null), !isLoadingCoupledAsset && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.dissolveTrainAfterTour",
      tagName: "span"
    }),
    checked: formData.dissolveTrainAfterTour,
    onChange: onDissolveTrainAfterTourChange
  }), (_formData$asset$coupl2 = formData.asset.coupledAssets) === null || _formData$asset$coupl2 === void 0 ? void 0 : _formData$asset$coupl2.map(function (coupledAsset, index) {
    var _coupledAsset$weight2;

    return /*#__PURE__*/_react["default"].createElement("div", {
      key: coupledAsset.id,
      className: "mt-4"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-base text-primary font-bold"
    }, coupledAsset.name), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.createTour.loading.weight"
      }),
      name: "weight",
      value: (_coupledAsset$weight2 = coupledAsset.weight) === null || _coupledAsset$weight2 === void 0 ? void 0 : _coupledAsset$weight2.toString(),
      onChange: function onChange(weight) {
        return onWeightChange(index, weight);
      },
      maxLength: 64
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
      type: "text",
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.createTour.loading.nhmCode"
      }),
      name: "nhmCode",
      value: coupledAsset.nhmCode,
      onChange: function onChange(nhmCode) {
        return onCoupledAssetPropChange(index, 'nhmCode', nhmCode);
      },
      maxLength: 64
    }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
      type: "text",
      label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
        id: "widgets.tourBoard.rail.createTour.loading.description"
      }),
      name: "productDescription",
      value: coupledAsset.productDescription,
      onChange: function onChange(productDescription) {
        return onCoupledAssetPropChange(index, 'productDescription', productDescription);
      },
      maxLength: 64
    }));
  }))), ((_formData$asset4 = formData.asset) === null || _formData$asset4 === void 0 ? void 0 : _formData$asset4.id) && !(0, _mapping.isCoupledAsset)((_formData$asset5 = formData.asset) === null || _formData$asset5 === void 0 ? void 0 : _formData$asset5.type) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.weight"
    }),
    name: "weight",
    value: (_formData$asset$coupl3 = formData.asset.coupledAssets) === null || _formData$asset$coupl3 === void 0 ? void 0 : (_formData$asset$coupl4 = _formData$asset$coupl3[0]) === null || _formData$asset$coupl4 === void 0 ? void 0 : (_formData$asset$coupl5 = _formData$asset$coupl4.weight) === null || _formData$asset$coupl5 === void 0 ? void 0 : _formData$asset$coupl5.toString(),
    onChange: function onChange(weight) {
      return onWeightChange(0, weight);
    },
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    type: "text",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.nhmCode"
    }),
    name: "nhmCode",
    value: (_formData$asset$coupl6 = formData.asset.coupledAssets) === null || _formData$asset$coupl6 === void 0 ? void 0 : (_formData$asset$coupl7 = _formData$asset$coupl6[0]) === null || _formData$asset$coupl7 === void 0 ? void 0 : _formData$asset$coupl7.nhmCode,
    onChange: function onChange(nhmCode) {
      return onCoupledAssetPropChange(0, 'nhmCode', nhmCode);
    },
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    type: "text",
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.description"
    }),
    name: "productDescription",
    value: (_formData$asset$coupl8 = formData.asset.coupledAssets) === null || _formData$asset$coupl8 === void 0 ? void 0 : (_formData$asset$coupl9 = _formData$asset$coupl8[0]) === null || _formData$asset$coupl9 === void 0 ? void 0 : _formData$asset$coupl9.productDescription,
    onChange: function onChange(productDescription) {
      return onCoupledAssetPropChange(0, 'productDescription', productDescription);
    },
    maxLength: 64
  }))), !isLoadingAssets && assetSelection === CREATE_NEW_ASSET && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    value: (_formData$asset6 = formData.asset) === null || _formData$asset6 === void 0 ? void 0 : _formData$asset6.name,
    onChange: onAssetNameChange,
    type: "text",
    error: (_touched$asset = touched.asset) !== null && _touched$asset !== void 0 && _touched$asset.name && (_errors$asset = errors.asset) !== null && _errors$asset !== void 0 && _errors$asset.name ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.trainName.error"
    }) : null,
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.trainName",
      tagName: "span"
    }, function (message) {
      return "".concat(message, "*");
    }),
    maxLength: 64
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Checkbox, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.dissolveTrainAfterTour",
      tagName: "span"
    }),
    checked: formData.dissolveTrainAfterTour,
    onChange: onDissolveTrainAfterTourChange
  }), (_formData$asset7 = formData.asset) === null || _formData$asset7 === void 0 ? void 0 : (_formData$asset7$coup = _formData$asset7.coupledAssets) === null || _formData$asset7$coup === void 0 ? void 0 : _formData$asset7$coup.map(function (coupledAsset, index) {
    var _touched$asset2, _touched$asset2$coupl, _errors$asset2, _errors$asset2$couple, _coupledAsset$weight3;

    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement("div", {
        key: index,
        className: _loadingStepModule["default"].asset
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center"
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
        icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Asset, {
          className: "fill-primary inline-block"
        }),
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.loading.asset"
        }, function (message) {
          return "".concat(message, "*");
        }),
        source: assetDropdownOptions,
        value: coupledAsset.id,
        valueType: "Integer",
        onChange: function onChange(id) {
          return onCoupledAssetChange(index, id);
        },
        error: (_touched$asset2 = touched.asset) !== null && _touched$asset2 !== void 0 && (_touched$asset2$coupl = _touched$asset2.coupledAssets) !== null && _touched$asset2$coupl !== void 0 && _touched$asset2$coupl[index] && (_errors$asset2 = errors.asset) !== null && _errors$asset2 !== void 0 && (_errors$asset2$couple = _errors$asset2.coupledAssets) !== null && _errors$asset2$couple !== void 0 && _errors$asset2$couple[index] ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.asset.error"
        }) : null
      }), formData.asset.coupledAssets.length > 1 && /*#__PURE__*/_react["default"].createElement("button", {
        className: "focus:outline-none",
        title: intl.formatMessage({
          id: 'widgets.tourBoard.rail.createTour.loading.asset.remove'
        }),
        onClick: function onClick() {
          return onRemoveCoupledAssetClicked(index);
        }
      }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
        className: _loadingStepModule["default"].removeAsset
      }))), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.loading.weight"
        }),
        name: "weight",
        value: (_coupledAsset$weight3 = coupledAsset.weight) === null || _coupledAsset$weight3 === void 0 ? void 0 : _coupledAsset$weight3.toString(),
        onChange: function onChange(weight) {
          return onWeightChange(index, weight);
        },
        maxLength: 64
      }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
        type: "text",
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.loading.nhmCode"
        }),
        name: "nhmCode",
        value: coupledAsset.nhmCode,
        onChange: function onChange(nhmCode) {
          return onCoupledAssetPropChange(index, 'nhmCode', nhmCode);
        },
        maxLength: 64
      }), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
        type: "text",
        label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
          id: "widgets.tourBoard.rail.createTour.loading.description"
        }),
        name: "productDescription",
        value: coupledAsset.productDescription,
        onChange: function onChange(productDescription) {
          return onCoupledAssetPropChange(index, 'productDescription', productDescription);
        },
        maxLength: 64
      }))
    );
  }), /*#__PURE__*/_react["default"].createElement("button", {
    className: "inline-flex items-center cursor-pointer font-bold my-4 focus:outline-none",
    onClick: onAddCoupledAssetClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "inline-block fill-primary mr-2 cursor-pointer"
  }), /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.rail.createTour.loading.addAsset"
  }))), !isLoadingLinkedPortals && assetSelection === DATA_REQUEST && /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Autocomplete, {
    label: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "widgets.tourBoard.rail.createTour.loading.dataRequestedFrom"
    }),
    source: linkedPortalSource,
    value: (_formData$dataRequest2 = formData.dataRequest) === null || _formData$dataRequest2 === void 0 ? void 0 : _formData$dataRequest2.haulerPortalId,
    onChange: function onChange(id) {
      return onDataRequestPortalChange(parseInt(id, 10) || null);
    }
  }));
};

LoadingStep.propTypes = {
  formData: _propTypes["default"].shape({
    dissolveTrainAfterTour: _propTypes["default"].bool,
    asset: _propTypes["default"].shape({
      id: _propTypes["default"].number,
      name: _propTypes["default"].string,
      type: _propTypes["default"].number,
      coupledAssets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        id: _propTypes["default"].number,
        name: _propTypes["default"].string,
        weight: _propTypes["default"].number,
        nhmCode: _propTypes["default"].string,
        productDescription: _propTypes["default"].string
      }))
    }),
    dataRequest: _propTypes["default"].shape({
      haulerPortalId: _propTypes["default"].number
    })
  }),
  isNewTour: _propTypes["default"].bool,
  assetSelection: _propTypes["default"].string,
  isLoadingCoupledAssets: _propTypes["default"].bool,
  setFieldValue: _propTypes["default"].func,
  setFieldTouched: _propTypes["default"].func,
  setAssetSelection: _propTypes["default"].func,
  errors: _propTypes["default"].shape({
    asset: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      name: _propTypes["default"].string,
      coupledAssets: _propTypes["default"].bool
    })
  }),
  touched: _propTypes["default"].shape({
    asset: _propTypes["default"].shape({
      id: _propTypes["default"].string,
      name: _propTypes["default"].string,
      coupledAssets: _propTypes["default"].bool
    })
  })
};

var noop = function noop() {};

LoadingStep.defaultProps = {
  formData: {},
  isNewTour: true,
  assetSelection: CREATE_NEW_ASSET,
  isLoadingCoupledAssets: false,
  setFieldValue: noop,
  setFieldTouched: noop,
  setAssetSelection: noop,
  touched: {},
  errors: {}
};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(['module.tour.rail'])(LoadingStep);

exports["default"] = _default;